export const ACCOUNT_STATUSES = {
  ACTIVE: 'active',
  BLOCKED: 'blocked',
  PENDING_VERIFICATION: 'pending_verification',
} as const;

export type AccountStatus = typeof ACCOUNT_STATUSES[keyof typeof ACCOUNT_STATUSES];
